import { createFileRoute, redirect } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";

// Legacy /articles redirect — Google has ~20 indexed URLs at this pattern.
// 301: the /articles index is permanently retired in favour of /blog.
export const Route = createFileRoute("/articles/")({
  head: () => seoHead("/articles/"),
  beforeLoad: () => {
    throw redirect({ to: "/blog", replace: true, statusCode: 301 });
  },
});